import dayjs from 'dayjs';
import { FC } from 'react';
import { DateHeaderProps } from 'react-big-calendar';

export const MonthDateHeader: FC<DateHeaderProps> = ({ date }) => {
  return (
    <div className="month-day">
      <div className="month-day-content">{dayjs(date).format('D')}</div>
    </div>
  );
};
